var ProductBundlePageSlider = {},
    $productBundlePageSlider;

ProductBundlePageSlider = {
    init() {
        $productBundlePageSlider = $('.js-product-bundle-page-slider');

        if ($productBundlePageSlider.length === 0) {
            return;
        }

        $.each($productBundlePageSlider, function () {
            let $slider = $(this);

			$slider.flickity(
				{
					cellAlign: 'left',
					contain: true,
					prevNextButtons: true,
					pageDots: false,
					wrapAround: true,
					on: {
						ready: function () {
							$slider.addClass('first-el');
						},
					},
				}
			);

        });
    },
}

$(function () {
	ProductBundlePageSlider.init();
});

window.ProductBundlePageSlider = ProductBundlePageSlider;



// WEBPACK FOOTER //
// ./scripts/components/sliders/product-bundle-page-slider.js